export const skills = [
  "React",
  "React Hooks",
  "React Router",
  "TypeScript",
  "Angular",
  "Angular JS",
  "Git",
  "GitHub Pull Requests & Review",
  "Bitbucket",
  "NPM",
  "Redux",
  "Redux (Toolkit)",
  "Redux-Saga",
  "Working with API (fetch, axios)",
  "Promises, Async/Await",
  "Error handling",
  "ES6+",
  "Semantic & accessible HTML",
  "Responsive Web Design",
  "Immutability",
  "Styled Components",
  "SASS",
  "CSS Flexbox & Grid",
  "CSS BEM convention",
  "WCAG",
  "Markdown",
  "Scrum",
  "Jira",
  "Trello",
  "Figma",
  "PHP - basics",
  "WordPress - basics",
  "Photoshop - basics",
];

export const toLearn = [
  "Angular. Never too much of it. ❤️",
];